import React from "react";
import { TCustomer } from "../../../../types/Types";
import SubjectCard from "./SubjectCard";
import { AcademicCapIcon } from "@heroicons/react/24/outline";

interface SubjectsListProps {
  subjects: TCustomer["subjects"];
  isUpdating: string | null;
  onToggleApproval: (subjectId: string, currentStatus: boolean) => void;
}

const SubjectsList = ({
  subjects,
  isUpdating,
  onToggleApproval,
}: SubjectsListProps) => {
  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden h-full">
      <div className="p-6 border-b border-gray-50 flex items-center justify-between bg-gray-50/30">
        <div>
          <h2 className="text-xl font-black text-gray-900">
            Enrolled Subjects
          </h2>
          <p className="text-sm text-gray-500 mt-0.5">
            {subjects.length} subjects found for this student
          </p>
        </div>
      </div>

      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {subjects
            .filter((s) => s.subjectId)
            .map((s, i) => (
              <SubjectCard
                key={i}
                subject={s}
                isUpdating={isUpdating === s.subjectId._id}
                onToggleApproval={onToggleApproval}
              />
            ))}

          {subjects.length === 0 && (
            <div className="col-span-full py-20 bg-gray-50/50 rounded-3xl border-2 border-dashed border-gray-200 flex flex-col items-center justify-center text-gray-400">
              <AcademicCapIcon className="w-12 h-12 mb-3 opacity-20" />
              <p className="font-medium">No subjects found for this student</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubjectsList;
